import React from 'react'
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom'
import {AuthProvider} from './components/context/AuthContext'
import PrivateRoute from './components/misc/PrivateRoute'
import Navbar from './components/misc/Navbar'
import Home from './components/home/Home'
import About from './components/home/About'
import Login from './components/home/Login'
import Signup from './components/home/Signup'
import AdminPage from './components/admin/AdminPage'
import UserPage from './components/user/UserPage'
import TripListPage from './components/user/TripListPage'
import TripFormPage from './components/user/TripFormPage'
import BookingPage from './components/user/BookingPage'
import MyTripsPage from './components/user/MyTripsPage'
import Inbox from "./components/user/Inbox";
import Profile from "./components/user/Profile";
import ReviewFormPage from "./components/user/ReviewFormPage";
import ReviewsPage from "./components/user/ReviewsPage";
import ReportFormPage from "./components/user/ReportFormPage";
import ReportListPage from "./components/user/ReportListPage";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navbar/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/about' element={<About/>}/>
          <Route path='/login' element={<Login/>}/>
          <Route path='/signup' element={<Signup/>}/>
          <Route path="/adminpage" element={<PrivateRoute><AdminPage/></PrivateRoute>}/>
          <Route path="/userpage" element={<PrivateRoute><UserPage/></PrivateRoute>}/>
          <Route path="/trips" element={<PrivateRoute><TripListPage/></PrivateRoute>}/>
          <Route path="/mytrips" element={<PrivateRoute><MyTripsPage/></PrivateRoute>}/>
          <Route path="/inbox" element={<PrivateRoute><Inbox/></PrivateRoute>}/>
          <Route path="/profile" element={<PrivateRoute><Profile/></PrivateRoute>}/>
          <Route path="/createtrip" element={<PrivateRoute><TripFormPage/></PrivateRoute>}/>
          <Route path="/booking/:tripId" element={<PrivateRoute><BookingPage/></PrivateRoute>}/>
          <Route path="/review/:tripId/:userId" element={<PrivateRoute><ReviewFormPage/></PrivateRoute>}/>
          <Route path="/reviews/:userId" element={<PrivateRoute><ReviewsPage/></PrivateRoute>}/>
          <Route path="/createreport" element={<PrivateRoute><ReportFormPage/></PrivateRoute>}/>
          <Route path="/searchreports" element={<ReportListPage/>}/>
          <Route path="/*" element={<Navigate to="/"/>}/>
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
